import { useEffect, useRef } from "react";

// Wraps content and adds a reveal-on-scroll animation.
export default function Reveal({ children, className = "", delay = 0 }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(
                            () => entry.target.classList.add("is-visible"),
                            delay,
                        );
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15 },
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [delay]);

    return (
        <div ref={ref} className={`reveal ${className}`}>
            {children}
        </div>
    );
}
